export default __webpack_public_path__ + "static/media/arrow_right.1d706d7a.svg";